var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXRed = function SvgXRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D92D20",
    d: "m7.52 14.917 2.98-2.98 2.979 2.98 1.437-1.438-2.979-2.979 2.98-2.98-1.438-1.437-2.98 2.98-2.978-2.98-1.438 1.438 2.98 2.979-2.98 2.98zm2.98 4.25q-1.785 0-3.364-.678a8.7 8.7 0 0 1-2.764-1.861 8.7 8.7 0 0 1-1.861-2.764 8.45 8.45 0 0 1-.678-3.364q0-1.81.679-3.385a8.8 8.8 0 0 1 1.864-2.761 8.6 8.6 0 0 1 6.124-2.52 8.59 8.59 0 0 1 6.145 2.52 8.594 8.594 0 0 1 2.52 6.148 8.5 8.5 0 0 1-.665 3.363 8.6 8.6 0 0 1-1.854 2.758 8.8 8.8 0 0 1-2.762 1.865 8.5 8.5 0 0 1-3.384.679m0-2.042q2.76 0 4.693-1.932t1.932-4.693-1.932-4.693Q13.26 3.875 10.5 3.875T5.807 5.807Q3.875 7.74 3.875 10.5t1.932 4.693q1.932 1.932 4.693 1.932"
  })));
};
export default SvgXRed;